import React from "react";
import { FormControl, FormHelperText, InputAdornment, OutlinedInput, Stack } from "@mui/material";

import { isValidAmount } from "../helpers";
import { FlagsDropdown } from "./FlagsDropdown";
import { StyledInput } from "./StyledComponents/GoalAmountInputStyles";

export function GoalAmountInput({ selectedCurrencyOption, currencyChangeHandler, amountProps, disableCurrencyEdit = false }) {

    const validateDonationAmount = (event) => {
        if (!isValidAmount(event.key)) {
            event.preventDefault();
        }
    }
    return <StyledInput sx={{ width: '100%' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center">

            <FlagsDropdown selectedOption={selectedCurrencyOption} onChange={currencyChangeHandler} disableEdit={disableCurrencyEdit} />

            <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                    {...amountProps}
                    className="AmountTextField"
                    onKeyPress={validateDonationAmount}
                    size='small'
                    sx={{
                        '& input::placeholder': {
                            color: `#717171 !important`
                        }
                    }}
                    endAdornment={<InputAdornment position="end" sx={{marginLeft: '5px', '& p': {marginTop: '0 !important'}}}>.00</InputAdornment>}
                />
            </FormControl>
        </Stack>

        <FormHelperText error>{amountProps.helpertext}</FormHelperText>
    </StyledInput>
}